import { Component, OnInit } from "@angular/core";
import { DataService_MultiStationCurrentVisitors } from "./shared/data.service";
import { Router } from "@angular/router";
import { LocalstorageService, UserService } from "../../../shared";
import { DialogService } from "primeng/dynamicdialog";
import { ReportFileTypeDialogComponent } from "../../student/shared/report-file-type-dialog/report-file-type-dialog.component";
import { ReportService } from "../../Report/report.service";

@Component({
	selector: "app-multi-station-current-visitors",
	templateUrl: "./multi-station-current-visitors.component.html",
	styleUrls: ["./multi-station-current-visitors.component.css"],
})
export class MultiStationCurrentVisitorsComponent implements OnInit {
	constructor(
		private visitorService: DataService_MultiStationCurrentVisitors,
		private router: Router,
		private userService: UserService,
		private dialogService: DialogService,
		private reportService: ReportService,
		private localService: LocalstorageService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		//
		//	10.15 Try to select a facility based on the last school that was selected
		//
		var lastSchool = this.localService.getItem("SchoolSelector_School");
		if (lastSchool != undefined && lastSchool.SchoolID != undefined) {
			this.LastSchoolID = lastSchool.SchoolID;
		}

		this.loadFacility();
	}

	/////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////

	user: any;
	LastSchoolID: number = -1;

	LoadingFacility: boolean = false;
	Facility: any;
	lstFacility: any = [];

	LoadingTable: boolean = false;
	SelectedPerson: any;
	lstPerson: any = [];

	pagerows: any = 10;
	pagefirst: any = 0;

	lstLastFacilityName: any = [];
	lstLastFacilityLocationName: any = [];
	lstLastScanStation: any = [];
	lstDestination: any = [];
	lstVisitorReasonDesc: any = [];
	lstWaitingForVerificationDesc: any = [];

	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "LastEntryDTDesc", header: "Last Entry" },
		{ field: "LastFacilityName", header: "Last Facility" },
		{ field: "LastFacilityLocationName", header: "Last Location" },
		{ field: "LastScanStation", header: "Station" },
		{ field: "Destination", header: "Destination" },
		{ field: "VisitorReasonDesc", header: "Reason" },
		{ field: "PassComment", header: "Comments" },
		// { field: 'WaitingForVerificationDesc', header: 'Waiting For Verification' },
	];

	ImageDict: Map<number, string> = new Map(); //Dictionary that matches Visitor Pass IDs to base64 of image
	lstImageCalls: any = [];

	Processing: boolean = false;

	errorMessage: string = "";

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////////

	loadFacility() {
		this.LoadingFacility = true;

		var result = this.visitorService.VisitorFacilitySelectList(this.LastSchoolID);
		result.subscribe(
			(response) => {
				this.lstFacility = response;

				this.lstFacility.unshift({
					FacilityID: -1,
					FacilityName: "All",
				});

				this.Facility = this.lstFacility[0];

				for (var z = 0; z < this.lstFacility.length; z++) {
					var next = this.lstFacility[z];

					if (next.Selected == true) {
						this.Facility = next;
					}
				}

				this.loadTable();

				this.LoadingFacility = false;
			},
			(error) => {
				this.LoadingFacility = false;
			}
		);
	}

	loadTable() {
		this.errorMessage = "";

		this.LoadingTable = true;

		var result = this.visitorService.CurrentVisitorsSelectList(this.Facility.FacilityID);
		result.subscribe(
			(response) => {
				this.lstPerson = response;

				for (var z = 0; z < this.lstPerson.length; z++) {
					var next = this.lstPerson[z];

					if (next.WaitingForVerification == true) {
						next.RouterLink = "/multistation/verifyvisitor/" + next.VisitorPassID;
					} else {
						next.RouterLink = "/multistation/viewlog/" + next.VisitorPassDetailID;
					}
				}

				//Load Data Filter Lists
				this.lstLastFacilityName = Array.from(new Set(this.lstPerson.map((item: any) => item.LastFacilityName))).sort();
				this.lstLastFacilityLocationName = Array.from(new Set(this.lstPerson.map((item: any) => item.LastFacilityLocationName))).sort();
				this.lstLastScanStation = Array.from(new Set(this.lstPerson.map((item: any) => item.LastScanStation))).sort();
				this.lstDestination = Array.from(new Set(this.lstPerson.map((item: any) => item.Destination))).sort();
				this.lstVisitorReasonDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.VisitorReasonDesc))).sort();
				this.lstWaitingForVerificationDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.WaitingForVerificationDesc))).sort();

				this.LoadingTable = false;
			},
			(error) => {
				this.LoadingTable = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////////
	onRefresh() {
		this.loadTable();
	}

	onPrint() {
		this.errorMessage = "";

		var ref = this.dialogService.open(ReportFileTypeDialogComponent, {
			header: "Report File Type",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response > 0) {
				this.onFinishPrint(response);
			}
		});
	}

	onFinishPrint(OutputTypeID) {
		var component = this;
		this.errorMessage = "";

		var strParam = this.GetStrParam();
		this.Processing = true;

		var reportID = 453;

		var result = this.reportService.Print(reportID, strParam, 0, OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.Processing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.Processing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: FacilityID
		strParam += this.Facility.FacilityID + "|FacilityID";

		//Parameter 2: UserID
		strParam += "," + this.user.userID + "|UserID";

		//Parameter 3: SchoolID
		strParam += "," + 0 + "|SchoolID";

		//Parameter 4: ImageLogo
		// strParam += "," + "8C87B20B-5813-4F74-8375-9898FD7B0C74" + "|Imagelogo";
		strParam += "," + "" + "|Imagelogo";

		return strParam;
	}
	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////////

	onFacilityChange(val) {
		this.Facility = val;

		this.loadTable();
	}

	onRowDblClick(Person) {
		this.SelectedPerson = Person;

		document.getElementById("Link" + Person.VisitorPassDetailID).click();
	}

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingFacility == true || this.LoadingTable == true;
	}

	GetPhotoData(VisitorPassID) {
		if (this.ImageDict.has(VisitorPassID)) {
			return this.ImageDict.get(VisitorPassID);
		} else {
			var found = false;

			for (var z = 0; z < this.lstImageCalls.length; z++) {
				var next = this.lstImageCalls[z];

				if (next == VisitorPassID) {
					found = true;
					break;
				}
			}

			if (found) {
				return "assets\\images\\loading.gif";
				//return this.ImageDict.get(-1); //Already made the webservice call
			} else {
				//Make the webservice call 1 time
				this.lstImageCalls = [...this.lstImageCalls, VisitorPassID]; //Add to list of calls made

				var result = this.visitorService.GetPhotoByVisitorPass(VisitorPassID);
				result.subscribe(
					(response: any) => {
						this.ImageDict.set(VisitorPassID, response.VisitorPhoto);

						return response.VisitorPhoto;
					},
					(error) => {
						return this.ImageDict.get(-1); //Missing Photo
					}
				);
			}
		}
	}

	/////////////////////////////////////////////////////////////////////////
}
